import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appMmYyMask]',
})
export class MmYyMaskDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
    event.preventDefault();
    event.stopPropagation();
  }

  ngAfterContentInit() {
    var value = this.ngControl.control.value;
    // this.onInputChange(value, false);
  }

  onInputChange(event, backspace) {
    let newVal = event.replace(/\D/g, '');
    if (backspace && newVal.length <= 20) {
      newVal = newVal.substring(0, newVal.length - 1);
    }
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length < 2) {
      newVal = newVal.replace(/^(\d{0,1})/, '$1');
    } else if (newVal.length === 2) {
      var reg = new RegExp('(0[1-9]|1[0-2])');
      if (reg.test(newVal)) {
        newVal = newVal.replace(/^(\d{0,2})/, '$1/');
      } else {
        newVal = newVal.substring(0, 1);
      }
    } else {
      newVal = newVal.substring(0, 4);
      newVal = newVal.replace(/^(\d{0,2})(\d{0,2})/, '$1/$2');
    }
    this.ngControl.valueAccessor.writeValue(newVal);
  }
}
